import React, { useState } from 'react';

interface NavItem {
  id: string;
  label: string;
  shortLabel?: string;
}

const navItems: NavItem[] = [
  { id: 'intro', label: 'Overview', shortLabel: 'Overview' },
  { id: 'situation', label: 'Your Situation', shortLabel: 'Situation' },
  { id: 'realestate', label: 'Understanding Real Estate', shortLabel: 'Real Estate' },
  { id: 'stockmarket', label: 'The Stock Market', shortLabel: 'Stocks' },
  { id: 'geography', label: 'Geography & Returns', shortLabel: 'Geography' },
  { id: 'property', label: 'The Property', shortLabel: 'Property' },
  { id: 'rent', label: 'Keep & Rent', shortLabel: 'Rent' },
  { id: 'sell', label: 'Sell & Invest', shortLabel: 'Sell' },
  { id: 'comparison', label: 'Head-to-Head', shortLabel: 'Compare' },
  { id: 'uncertainty', label: 'Uncertainty', shortLabel: 'Uncertainty' },
  { id: 'frameworks', label: 'Thinking Frameworks', shortLabel: 'Frameworks' },
  { id: 'recommendation', label: 'Recommendation', shortLabel: 'Recommend' },
  { id: 'decision', label: 'The Decision', shortLabel: 'Decide' },
  { id: 'sources', label: 'Sources', shortLabel: 'Sources' },
];

interface ReportNavProps {
  activeSection: string;
  onNavigate: (sectionId: string) => void;
}

export const ReportNav: React.FC<ReportNavProps> = ({ activeSection, onNavigate }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const activeItem = navItems.find(item => item.id === activeSection);

  const handleMobileNavigate = (sectionId: string) => {
    onNavigate(sectionId);
    setMobileMenuOpen(false);
  };

  return (
    <>
      {/* Desktop side navigation */}
      <nav className="hidden lg:block fixed left-8 top-32 z-40">
        <ul className="space-y-1">
          {navItems.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => onNavigate(item.id)}
                className={`
                  block w-full text-left px-3 py-2 text-sm transition-all duration-200
                  ${activeSection === item.id
                    ? 'bg-gray-100 text-gray-700 font-medium'
                    : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
                  }
                `}
              >
                {item.shortLabel || item.label}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* Mobile navigation - simple non-sticky dropdown at top */}
      <div className="lg:hidden border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="w-full flex items-center justify-between py-3 text-left"
          >
            <span className="text-sm font-medium text-gray-900">
              Jump to: {activeItem?.label || 'Navigate'}
            </span>
            <svg
              className={`w-4 h-4 text-gray-500 transition-transform flex-shrink-0 ${mobileMenuOpen ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {mobileMenuOpen && (
            <div className="border-t border-gray-200 bg-gray-50 -mx-4 px-4 py-2 max-h-64 overflow-y-auto">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleMobileNavigate(item.id)}
                  className={`
                    block w-full text-left py-2 text-sm
                    ${activeSection === item.id
                      ? 'text-gray-900 font-medium'
                      : 'text-gray-600'
                    }
                  `}
                >
                  {item.label}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ReportNav;
